import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import type { FieldValidation } from '@rjsf/utils';
import { ServiceBusTopicManager } from './ServiceBusTopicManager';
import { ServiceBusFormData } from './types';

function validateServiceBus(
  value: ServiceBusFormData | undefined,
  validation: FieldValidation,
) {
  if (!value) {
    validation.addError('Configuração do Service Bus é obrigatória');
    return;
  }

  if (!Array.isArray(value.changes)) {
    validation.addError('O campo changes deve ser um array');
    return;
  }

  for (let i = 0; i < value.changes.length; i++) {
    const ch = value.changes[i];
    if (!ch.key || typeof ch.key !== 'string') {
      validation.addError(`changes[${i}]: key inválida`);
      return;
    }
    if (ch.entityType !== 'topic' && ch.entityType !== 'subscription') {
      validation.addError(`changes[${i}]: entityType inválido`);
      return;
    }
    if (
      ch.action !== 'add' &&
      ch.action !== 'modify' &&
      ch.action !== 'delete'
    ) {
      validation.addError(`changes[${i}]: action inválida`);
      return;
    }
    if (ch.action === 'add' && !ch.newValue) {
      validation.addError(`changes[${i}]: add exige newValue`);
      return;
    }
    if (ch.action === 'modify' && (!ch.previousValue || !ch.newValue)) {
      validation.addError(
        `changes[${i}]: modify exige previousValue e newValue`,
      );
      return;
    }
    if (ch.action === 'delete' && !ch.previousValue) {
      validation.addError(`changes[${i}]: delete exige previousValue`);
      return;
    }
  }
}

export const ServiceBusTopicManagerFieldExtension = FormFieldBlueprint.make({
  name: 'service-bus-topic-manager',
  params: {
    field: async () =>
      createFormField({
        name: 'ServiceBusTopicManager',
        component: ServiceBusTopicManager as any,
        validation: (value, validation) =>
          validateServiceBus(value as ServiceBusFormData | undefined, validation),
        schema: makeFieldSchema({
          output: z => z.record(z.string(), z.unknown()),
          uiOptions: z =>
            z.object({
              projectId: z
                .number()
                .describe('GitLab project ID that stores the Service Bus YAML'),
              repoPath: z
                .string()
                .describe(
                  'GitLab repository path that stores the Service Bus YAML',
                ),
            }),
        }),
      }),
  },
});
